import React from 'react';
import { SpacingStack, TextV2 } from '@withjoy/joykit';

type StepHeaderProps = {
  heading: string;
  subheading: string;
};

export const StepHeader = ({ heading, subheading }: StepHeaderProps) => {
  return (
    <SpacingStack
      alignItems="center"
      gap="1rem"
      marginBottom="1rem"
    >
      <TextV2 typographyVariant="hed4">{heading}</TextV2>
      <TextV2>{subheading}</TextV2>
    </SpacingStack>
  );
};
